module.exports = __webpack_public_path__ + "img/4.251c2ef8.jpg";